






























































import { defineComponent, onMounted, ref, computed, onBeforeUnmount } from '@vue/composition-api'
import {
    handleWarningMessageToastV2,
    handleErrorMessageToastV2,
} from '@/common/util';

export default defineComponent({
    name: 'TitleSlotComponent',
    props: {
        num: { // 添加关键词数量（总的 关键词列表 + addKeywordList.length）
            type: Number,
            default: 3
        },
        wordListLength: { // 关键词列表长度（已经存在多少个关键词）
            type: Number,
            default: 0
        },
        loading: {
            type: Boolean,
            default: false
        },
        addReapeatList: { // 重复关键词列表
            type: Array,
            default: () => []
        }
    },
    setup(props, context) {
        const addKeywordList = ref<string[]>([]);
        const formRef = ref();
        onMounted(() => {
            addKeywordList.value = Array.from({ length: 1 }, () => '');
        });

        const addDisabled = computed(() => {
            return props.wordListLength + addKeywordList.value.length >= props.num;
        })

        // 判断是否有空的关键词
        const isNull = computed(() => addKeywordList.value.some(item => !item))


        const confirmDisabled = computed(() => {
            return isNull.value || props.loading;
        })

        const handleAddKeyword = () => {
            if(isNull.value) {
                handleErrorMessageToastV2('请填写完整的关键词');
                return;
            }
            context.emit('submit', addKeywordList.value);
        }

        const delKeyword = (index: number) => {
            if (addKeywordList.value.length <= 1) {
                handleWarningMessageToastV2('至少保留一个关键词');
                return;
            }
            addKeywordList.value.splice(index, 1);
        }

        const handleClose = () => {
            addKeywordList.value = [];
            context.emit('cancel');
        }

        return {
            formRef,
            addKeywordList,
            addDisabled,
            confirmDisabled,
            handleAddKeyword,
            handleClose,
            delKeyword
        }
    }
})
